import { Component, Input, OnInit, Injectable, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-files-path',
  templateUrl: './files-path.component.html',
  styleUrls: ['./files-path.component.scss']
})
export class FilesPathComponent implements OnInit {

  constructor(private http: HttpClient, private formBuilder: FormBuilder, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;

  ngOnInit() {
    this.Form = this.formBuilder.group({
      groupLogoBlue: ['',Validators.required],
      groupLogoWhite: ['', Validators.required],
      engineeringLogoBlue: ['',Validators.required],
      engineeringLogoWhite: ['', Validators.required],
      homeAbout: ['', Validators.required],
      // newsDetailsBanner: ['', Validators.required],
      // newsBanner: ['', Validators.required],
      footerForbes: ['', Validators.required],
      footerLogo: ['', Validators.required],
      footerNaac: ['', Validators.required],
      // pageAboutUsBanner: ['', Validators.required],
      // iqacBanner: ['', Validators.required],
      // facilitiesBanner: ['', Validators.required],
      // rankingsBanner: ['', Validators.required],
      // admissionsOverviewBanner: ['', Validators.required],
      // placementsOverviewBanner: ['', Validators.required],
      // ourRecruitersBanner: ['', Validators.required],
      ctcImage: ['', Validators.required],
      sectorwiseImage: ['', Validators.required],
      // labsLibrariesBanner: ['', Validators.required],
      // hkbkLifeOverviewBanner: ['', Validators.required],
      // instituteIndustryBanner: ['', Validators.required],
      // learningResourcesBanner: ['', Validators.required],
      // learningResourcesDetailBanner: ['', Validators.required],
      // facultyBanner: ['', Validators.required],
      // contactUsBanner: ['', Validators.required],
      // howToApplyBanner: ['', Validators.required],
      // indianStudentsBanner: ['', Validators.required],
      // internationalStudentsBanner: ['', Validators.required],
      navAbout : ['', Validators.required],
      navInstitutions : ['', Validators.required],
      navPrograms : ['', Validators.required],
      navAdmissions : ['', Validators.required],
      navPlacements : ['', Validators.required],
      navHKBKlife : ['', Validators.required],
      navResearchInnovation : ['', Validators.required],
      _id: [''],
    });
    this.http.get<any>(this.api_endpoint+'/filespathfindone/').subscribe(
        data => {
          if(data.data != null){
            this.action = 'Update';
            this.Form.patchValue({
              groupLogoBlue: data.data.groupLogoBlue,
              groupLogoWhite: data.data.groupLogoWhite,
              engineeringLogoBlue: data.data.engineeringLogoBlue,
              engineeringLogoWhite: data.data.engineeringLogoWhite,
              homeAbout: data.data.homeAbout,
              // newsDetailsBanner: data.data.newsDetailsBanner,
              // newsBanner: data.data.newsBanner,
              footerForbes: data.data.footerForbes,
              footerLogo: data.data.footerLogo,
              footerNaac: data.data.footerNaac,
              // pageAboutUsBanner: data.data.pageAboutUsBanner,
              // iqacBanner: data.data.iqacBanner,
              // facilitiesBanner: data.data.facilitiesBanner,
              // rankingsBanner: data.data.rankingsBanner,
              // admissionsOverviewBanner: data.data.admissionsOverviewBanner,
              // placementsOverviewBanner: data.data.placementsOverviewBanner,
              // ourRecruitersBanner: data.data.ourRecruitersBanner,
              ctcImage: data.data.ctcImage,
              sectorwiseImage: data.data.sectorwiseImage,
              // labsLibrariesBanner: data.data.labsLibrariesBanner,
              // hkbkLifeOverviewBanner: data.data.hkbkLifeOverviewBanner,
              // instituteIndustryBanner: data.data.instituteIndustryBanner,
              // learningResourcesBanner: data.data.learningResourcesBanner,
              // learningResourcesDetailBanner: data.data.learningResourcesDetailBanner,
              // facultyBanner: data.data.facultyBanner,
              // contactUsBanner: data.data.contactUsBanner,
              // howToApplyBanner: data.data.howToApplyBanner,
              // indianStudentsBanner: data.data.indianStudentsBanner,
              // internationalStudentsBanner: data.data.internationalStudentsBanner,
              navAbout : data.data.navAbout,
              navInstitutions : data.data.navInstitutions,
              navPrograms : data.data.navPrograms,
              navAdmissions : data.data.navAdmissions,
              navPlacements : data.data.navPlacements,
              navHKBKlife : data.data.navHKBKlife,
              navResearchInnovation : data.data.navResearchInnovation,
              _id: data.data._id,
            })
          }else{
            this.action = 'Submit';
            this.Form.patchValue({
              groupLogoBlue: '',
              groupLogoWhite: '',
              engineeringLogoBlue: '',
              engineeringLogoWhite: '',
              homeAbout: '',
              // newsDetailsBanner: '',
              // newsBanner: '',
              footerForbes: '',
              footerLogo: '',
              footerNaac: '',
              // pageAboutUsBanner: '',
              // iqacBanner: '',
              // facilitiesBanner: '',
              // rankingsBanner: '',
              // admissionsOverviewBanner: '',
              // placementsOverviewBanner: '',
              // ourRecruitersBanner: '',
              ctcImage: '',
              sectorwiseImage: '',
              // labsLibrariesBanner: '',
              // hkbkLifeOverviewBanner: '',
              // instituteIndustryBanner: '',
              // learningResourcesBanner: '',
              // learningResourcesDetailBanner: '',
              // facultyBanner: '',
              // contactUsBanner: '',
              // howToApplyBanner: '',
              // indianStudentsBanner: '',
              // internationalStudentsBanner: '',
              navAbout : '',
              navInstitutions : '',
              navPrograms : '',
              navAdmissions : '',
              navPlacements : '',
              navHKBKlife : '',
              navResearchInnovation : '',
              _id: '',
            })
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  get f() { return this.Form.controls; }

  onFormSubmit(action){

    this.submitted = true;
    if(action == 'Update'){
      var data = {
        "groupLogoBlue" : this.Form.value.groupLogoBlue,
        "groupLogoWhite" : this.Form.value.groupLogoWhite,
        "engineeringLogoBlue" : this.Form.value.engineeringLogoBlue,
        "engineeringLogoWhite" : this.Form.value.engineeringLogoWhite,
        "homeAbout" : this.Form.value.homeAbout,
        // "newsDetailsBanner" : this.Form.value.newsDetailsBanner,
        // "newsBanner" : this.Form.value.newsBanner,
        "footerForbes" : this.Form.value.footerForbes,
        "footerLogo" : this.Form.value.footerLogo,
        "footerNaac" : this.Form.value.footerNaac,
        // "pageAboutUsBanner" : this.Form.value.pageAboutUsBanner,
        // "iqacBanner" : this.Form.value.iqacBanner,
        // "facilitiesBanner" : this.Form.value.facilitiesBanner,
        // "rankingsBanner" : this.Form.value.rankingsBanner,
        // "admissionsOverviewBanner" : this.Form.value.admissionsOverviewBanner,
        // "placementsOverviewBanner" : this.Form.value.placementsOverviewBanner,
        // "ourRecruitersBanner" : this.Form.value.ourRecruitersBanner,
        "ctcImage" : this.Form.value.ctcImage,
        "sectorwiseImage" : this.Form.value.sectorwiseImage,
        // "labsLibrariesBanner" : this.Form.value.labsLibrariesBanner,
        // "hkbkLifeOverviewBanner" : this.Form.value.hkbkLifeOverviewBanner,
        // "instituteIndustryBanner" : this.Form.value.instituteIndustryBanner,
        // "learningResourcesBanner" : this.Form.value.learningResourcesBanner,
        // "learningResourcesDetailBanner" : this.Form.value.learningResourcesDetailBanner,
        // "facultyBanner" : this.Form.value.facultyBanner,
        // "contactUsBanner" : this.Form.value.contactUsBanner,
        // "howToApplyBanner" : this.Form.value.howToApplyBanner,
        // "indianStudentsBanner" : this.Form.value.indianStudentsBanner,
        // "internationalStudentsBanner" : this.Form.value.internationalStudentsBanner,
        "navAbout" : this.Form.value.navAbout,
        "navInstitutions" : this.Form.value.navInstitutions,
        "navPrograms" : this.Form.value.navPrograms,
        "navAdmissions" : this.Form.value.navAdmissions,
        "navPlacements" : this.Form.value.navPlacements,
        "navHKBKlife" : this.Form.value.navHKBKlife,
        "navResearchInnovation" : this.Form.value.navResearchInnovation,
        "admin" : sessionStorage.getItem('adminName'),
        "_id" : this.Form.value._id,
      };
      this.http.put<any>(this.api_endpoint+'/filespath', data).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Updated';
            this.class = 'btn btn-success';
          } 
          window.scrollTo(document.documentElement.clientWidth, 0);
          this.ngOnInit();
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }else if(action == 'Submit'){
      var data1 = {
        "groupLogoBlue" : this.Form.value.groupLogoBlue,
        "groupLogoWhite" : this.Form.value.groupLogoWhite,
        "engineeringLogoBlue" : this.Form.value.engineeringLogoBlue,
        "engineeringLogoWhite" : this.Form.value.engineeringLogoWhite,
        "homeAbout" : this.Form.value.homeAbout,
        // "newsDetailsBanner" : this.Form.value.newsDetailsBanner,
        // "newsBanner" : this.Form.value.newsBanner,
        "footerForbes" : this.Form.value.footerForbes,
        "footerLogo" : this.Form.value.footerLogo,
        "footerNaac" : this.Form.value.footerNaac,
        // "pageAboutUsBanner" : this.Form.value.pageAboutUsBanner,
        // "iqacBanner" : this.Form.value.iqacBanner,
        // "facilitiesBanner" : this.Form.value.facilitiesBanner,
        // "rankingsBanner" : this.Form.value.rankingsBanner,
        // "admissionsOverviewBanner" : this.Form.value.admissionsOverviewBanner,
        // "placementsOverviewBanner" : this.Form.value.placementsOverviewBanner,
        // "ourRecruitersBanner" : this.Form.value.ourRecruitersBanner,
        "ctcImage" : this.Form.value.ctcImage,
        "sectorwiseImage" : this.Form.value.sectorwiseImage,
        // "labsLibrariesBanner" : this.Form.value.labsLibrariesBanner,
        // "hkbkLifeOverviewBanner" : this.Form.value.hkbkLifeOverviewBanner,
        // "instituteIndustryBanner" : this.Form.value.instituteIndustryBanner,
        // "learningResourcesBanner" : this.Form.value.learningResourcesBanner,
        // "learningResourcesDetailBanner" : this.Form.value.learningResourcesDetailBanner,
        // "facultyBanner" : this.Form.value.facultyBanner,
        // "contactUsBanner" : this.Form.value.contactUsBanner,
        // "howToApplyBanner" : this.Form.value.howToApplyBanner,
        // "indianStudentsBanner" : this.Form.value.indianStudentsBanner,
        // "internationalStudentsBanner" : this.Form.value.internationalStudentsBanner,
        "navAbout" : this.Form.value.navAbout,
        "navInstitutions" : this.Form.value.navInstitutions,
        "navPrograms" : this.Form.value.navPrograms,
        "navAdmissions" : this.Form.value.navAdmissions,
        "navPlacements" : this.Form.value.navPlacements,
        "navHKBKlife" : this.Form.value.navHKBKlife,
        "navResearchInnovation" : this.Form.value.navResearchInnovation,
        "admin" : sessionStorage.getItem('adminName'),
      };
      this.http.post<any>(this.api_endpoint+'/filespath', data1).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          } 
          window.scrollTo(document.documentElement.clientWidth, 0);
          this.ngOnInit();
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }
  }


}
